import { render, staticRenderFns } from "./ModalContractDepartamentComponent.vue?vue&type=template&id=1c649704"
import script from "./ModalContractDepartamentComponent.vue?vue&type=script&lang=js"
export * from "./ModalContractDepartamentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports